export default __webpack_public_path__ + "static/media/2.e53db1e1.jpg";